"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceClient = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ble_utils_1 = require("../lib/ble-utils");
const c = __importStar(require("../lib/constants"));
const socket_1 = require("../lib/socket");
const insai_1 = require("./insai");
const muse_1 = require("./muse");
const neorhythm_1 = require("./neorhythm");
class DeviceClient extends socket_1.SocketClient {
    constructor(props) {
        super(props);
        this.connectionStatus = new rxjs_1.BehaviorSubject(false);
        this.deviceName = null;
        this.gatt = null;
        this.selectedDevice = null;
        this.tryReconnect = false; // try to reconnect with device when connection is lost
        this.props = props;
    }
    handleDisconnect() {
        // TODO: fix EventEmitter Memory leak
        // @ts-ignore
        rxjs_1.fromEvent(this.selectedDevice.gatt.device, 'gattserverdisconnected')
            .pipe(operators_1.first())
            .subscribe(() => {
            this.gatt = null;
            this.connectionStatus.next(false);
            console.log('Disconnected');
            //this.selectedDevice!.injectMarker('Disconnected')
            if (this.tryReconnect) {
                ble_utils_1.exponentialBackOff(3, 2000, () => this.connect({ device: this.device, tryReconnect: true }), () => {
                    console.log('Restarting data stream...');
                    this.selectedDevice.start();
                    this.selectedDevice.openStream(this.selectedDevice.id);
                    console.log('Reconnected');
                    this.selectedDevice.injectMarker('Reconnected');
                }, () => console.log('Failed Reconnecting'));
            }
        });
    }
    async connect(config) {
        const { device, tryReconnect } = config || {};
        this.tryReconnect = !!tryReconnect;
        if (!device) {
            // use browser api
            // @ts-ignore
            this.device = await navigator.bluetooth.requestDevice({
                filters: [{ services: [c.MUSE_SERVICE] }, { services: [c.NEORHYTHM_SERVICE_ID] }, { services: [c.INSAI_SERVICE] }],
                optionalServices: [c.NEORHYTHM_SERVICE_UUID, c.NEORHYTHM_SERVICE],
            });
        }
        else {
            this.device = device;
        }
        this.gatt = await this.device.gatt.connect();
        if (!this.selectedDevice) {
            if (this.device.name.startsWith('Muse', 0)) {
                //console.log('Muse found')
                this.selectedDevice = new muse_1.MuseDataClient({ uri: this.props.uri });
            }
            else if (this.device.name.startsWith('NeoRhythm', 0)) {
                //console.log('NeoRhythm found')
                this.selectedDevice = new neorhythm_1.NeoRhythmDataClient({ uri: this.props.uri });
            }
            else if (this.device.name.startsWith('Insai', 0)) {
                //console.log('Insai found')
                this.selectedDevice = new insai_1.InsaiDataClient({ uri: this.props.uri });
            }
        }
        this.selectedDevice.gatt = this.gatt;
        this.handleDisconnect();
        await this.selectedDevice.initialize();
        this.connectionStatus.next(true);
    }
    userDisconnect() {
        if (this.gatt) {
            this.selectedDevice.stop();
            this.selectedDevice = null;
            this.tryReconnect = false; // user initiated disconnect should not trigger reconnect
            this.gatt.disconnect();
            this.connectionStatus.next(false);
        }
    }
}
exports.DeviceClient = DeviceClient;
//# sourceMappingURL=device.js.map